let chunkPrefetchStarted = false;

export function prefetchBuyVignetteDocument(href) {
    const raw = String(href || '').trim();
    if (!raw || typeof document === 'undefined') return;

    let absolute;
    try {
        absolute = new URL(raw, window.location.origin).href;
    } catch (e) {
        return;
    }

    const existing = document.querySelectorAll('link[data-cv-prefetch-buy], link[rel="prefetch"][as="document"]');
    for (const node of existing) {
        if (node.href === absolute) return;
    }

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = absolute;
    link.setAttribute('data-cv-prefetch-buy', '1');
    document.head.appendChild(link);
}

/** Same webpack chunk the buy-vignette island loads after navigation. */
export function prefetchBuyVignetteChunk() {
    if (chunkPrefetchStarted || typeof document === 'undefined') return;
    if (document.querySelector('buy-vignette')) return;
    chunkPrefetchStarted = true;
    import(/* webpackChunkName: 'buy-vignette' */ '../components/BuyVignette/BuyVignette.vue').catch(() => {
        chunkPrefetchStarted = false;
    });
}
